import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const getEmergenciaTicket   = (id)   => api.get(`/emergencia/ticket/${id}`).then(r => r.data);
export const getEmergenciaTickets  = ()     => api.get("/emergencia/tickets").then(r => r.data);
export const postEmergenciaTicket  = (body) => api.post("/emergencia/tickets", body).then(r => r.data);
export const putEmergenciaAtribuir = (id, body) => api.put(`/emergencia/tickets/${id}/atribuir`, body).then(r => r.data);
